module.exports = __webpack_public_path__ + "media/images/thumbnails/thumbs_date-006d4d7bb4ef134c929b455662acb7e1.jpg";